import { useState } from 'react';
import { Bot } from 'lucide-react';
import { useWaapBotCharts, BOT_TIME_RANGES, type BotTimeRange } from '@/api/waap';
import { useWaapWebsite } from '@/pages/services/waap/waap-context';
import { WaapAnalyticsBoard } from './WaapAnalyticsBoard';

/**
 * Analytics → Bot Management — NATIVE charts (Superset dashboard 62) rendered
 * through the shared board shell. Distinct from the left-nav Bot Management
 * feature (the strategy-rules list) — this is the analytics board.
 */
export function BotManagementAnalyticsTab() {
  const { selected } = useWaapWebsite();
  const [range, setRange] = useState<BotTimeRange>('Last 24 Hours');
  const [domains, setDomains] = useState<string[]>([]);
  const query = useWaapBotCharts(selected?.domainId, range, domains);
  return (
    <WaapAnalyticsBoard
      icon={<Bot size={26} />}
      label="bot management"
      ranges={BOT_TIME_RANGES}
      range={range}
      onRangeChange={setRange}
      domains={domains}
      onDomainsChange={setDomains}
      query={query}
    />
  );
}
